import Vue from "vue";
import Router from "vue-router";
const originalPush = Router.prototype.push;
// 解决路由同一个进入同一个
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
const exp = r => require.ensure([], () => r(require("@/components/exp")));
const errorPage = r =>
  require.ensure([], () => r(require("@/components/errorPage")));
const home = r => require.ensure([], () => r(require("@/components/home")));
const login = r => require.ensure([], () => r(require("@/components/login")));
const register = r =>
  require.ensure([], () => r(require("@/components/register")));
const setPass = r =>
  require.ensure([], () => r(require("@/components/setPass")));
const content = r =>
  require.ensure([], () => r(require("@/components/content")));
const recipient = r =>
  require.ensure([], () => r(require("@/components/recipient")));
const GoogleCollection = r =>
  require.ensure([], () => r(require("@/components/GoogleCollection")));

Vue.use(Router);
const router = new Router({
  mode: "history",
  base: "/user",
  routes: [
    {
      path: "*",
      component: errorPage
    },
    //登录
    {
      path: "/",
      name: "login",
      component: login,
      meta: {
        title: "",
        keepAlive: false
      }
    },
    //注册
    {
      path: "/register",
      name: "register",
      component: register,
      meta: {
        title: "",
        keepAlive: false
      }
    },
    {
      path: "/setPass",
      name: "setPass",
      component: setPass
    },
    {
      path: "/home",
      component: home,
      children: [
        {
          path: "/content",
          name: "content",
          component: content
        },
        {
          path: "/recipient",
          name: "recipient",
          component: recipient
        },
        {
          path: "/GoogleCollection",
          name: "GoogleCollection",
          component: GoogleCollection
        },

        {
          path: "/exp",
          name: "exp",
          component: exp
        }
      ]
    }
  ]
});

// function getAbsolutePath() {
// 	let path = location.pathname
// 	return path.substring(0, path.lastIndexOf('/') + 1)

// }

//路由守卫
router.beforeEach((to, from, next) => {
  //设置标题
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  next();
});

router.afterEach(to => {
  if (to.name === "exp" || to.path === "/exp") {
    // 确保在 DOM 更新后执行
    Vue.nextTick(() => {
      if (typeof gtag !== "undefined") {
        gtag("event", "conversion", {
          send_to: "AW-11243053297/KtstCN-RoOEbEPHBjfEp",
          value: 1.0,
          currency: "USD"
        });
      }
    });
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js